import React from "react";
import ReactDOM from "react-dom";
import regeneratorRuntime from "regenerator-runtime";
import AppContainer from "./Components/AppContainer";
import CartAbandonment from "./Models/CartAbandonment";
import Ajax from "./Models/Ajax";
import WebsiteConfigurationProcessor from "./Models/WebsiteConfigurationProcessor";

const versionTag = "v3/chatter.js";
const containerId = "live-insights-tag";

console.debug(`[${versionTag}]: start load`);

(function(window) {
  "use strict";

  if (window.chatter) {
    console.debug(`[${versionTag}]: tag already loaded, short circuiting`);
  } else {
    console.debug(`[${versionTag}]: creating object`);

    window.chatter = {
      init: function() {
        console.debug(`[${versionTag}]: start init`);

        let d = window.document.createElement("div");
        d.id = containerId;
        document.body.append(d);
        let chatter_config = arguments[0];

        let container = document.getElementById(containerId);
        if (container) {
          console.debug(`[${versionTag}]: container found, rendering`);
          const connection = new Ajax(chatter_config);

          connection.fetchConfiguration().then((websiteConfiguration) => {
            if (websiteConfiguration.status === "error" || websiteConfiguration.configuration.length === 0) {
              return;
            }

            const enabledConversations = WebsiteConfigurationProcessor.processConfiguration(websiteConfiguration);
            chatter_config.tag.survey_id = enabledConversations.alwaysOn && enabledConversations.alwaysOn.survey_id;
            ReactDOM.render(
              <AppContainer config={chatter_config} />,
              container
            );
          });
        } else {
          console.debug(`[${versionTag}]: container not found`);
        }

        console.debug(`[${versionTag}]: end init`);
      },
      completeAndUnmount: function() {
        CartAbandonment.disableCartAbandonmentDetection();
        let container = document.getElementById(containerId);
        console.debug(`[${versionTag}]: complete and unmount`);
        ReactDOM.unmountComponentAtNode(container);
      },
    };
  }
}) (window);

console.debug(`[${versionTag}]: firing event chatter-load-complete`);
window.dispatchEvent(new Event("chatter-load-complete"));
console.debug(`[${versionTag}]: end load`);
